import { createAction } from 'redux-actions';

export const setGlobalSocketClientAction = createAction('SET_GLOBAL_SOCKET_CLIENT');

export const setGlobalSocketClient = () => (dispatch) => {
  dispatch(setGlobalSocketClientAction(dispatch));
};

export const initGlobalSocketIOSocketClient = createAction(
  'INIT_GLOBAL_SOCKETIO_SOCKET_CLIENT',
);

export const clearGlobalSocketClientInStore = createAction(
  'CLEAR_GLOBAL_SOCKET_CLIENT',
);

export const stopGlobalSocketConnection = createAction(
  'STOP_GLOBAL_SOCKET_CONNECTION',
);

export const initGlobalSocketClient = (geoCode) => async (dispatch, getState) => {
  const { data: { currentUser } = {} } = getState();
  const geo = geoCode || window.TIEOUT.ENV.CURRENT_GEO;
  await dispatch(
    initGlobalSocketIOSocketClient({
      geoCode: geo,
      dispatch,
      currentUser,
    }),
  );
};

export const closeGlobalSocketClient = () => async (dispatch) => {
  await dispatch(stopGlobalSocketConnection());
  await dispatch(clearGlobalSocketClientInStore());
};
